import Image from "next/image";
import {
  addBasePathToStrapiMedia,
  formatStrapiEntity,
  StrapiEntity,
  StrapiImage,
} from "@/utils/strapi";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./ValueDescription.module.scss";

export type ValueDescriptionProps = {
  title: string;
  description: string;
  picto: StrapiEntity<StrapiImage>;
};

export const ValueDescription = ({
  title,
  description,
  picto,
}: ValueDescriptionProps) => {
  const strapiImage = formatStrapiEntity(picto);

  return (
    <div className={styles.valueDescription}>
      <div className={styles.pictoContainer}>
        <div className={styles.picto}>
          <Image
            src={addBasePathToStrapiMedia(strapiImage)}
            objectFit="contain"
            objectPosition="center"
            alt={strapiImage.alternativeText ?? ""}
            layout="fill"
          />
        </div>
      </div>
      <div className={styles.title}>{title}</div>
      <div
        className={styles.description}
        dangerouslySetInnerHTML={injectPurifiedHTML(
          removeEmptyRel(description)
        )}
      />
    </div>
  );
};
